import React, { useEffect, useRef, useState } from "react";
import {
  UploadingInput,
  BackNextButton,
  Input,
  Button,
  Modal, LoadingIcon, Select
} from "../../../../../common";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { isVerified, fetchStates } from "../../../../../../utils/Helper";
import { ReactComponent as Close } from "../../../../../../assets/icons/close-circle.svg";
import { useSelector, useDispatch } from "react-redux";

import {
  useCreateFinanceMutation,
  useCreateFinanceDraftMutation,
  useCreateFinanceDraftFetchMutation,
  useUpdateFinanceDraftMutation,
  useUpdateFinanceDraftDetailsMutation,
  useCreateCompanyFinanceDraftMutation,
  useCreateCompanyFinanceMutation,
  useUpdateFinanceMutation,
  useCreateCompanyMutation,
  useIndividualCompanyMutation,
  useGetCompanyQuery,
} from "../../../../../../store/Company/companyApiSlice";
import { SearchCompanyStatement } from "./SearchCompanyStatement";
import useCompanyUpdate from "../useCompanyFollowUpdate";
import { uploadFilePath } from "../../../../../../constants/s3UploadPath";
import { ReactComponent as Verified } from "../../../../../../assets/icons/verified.svg";
import { ReactComponent as Declined } from "../../../../../../assets/icons/cancel.svg";
import { ReactComponent as Requested } from "../../../../../../assets/icons/pending.svg";
import { ReactComponent as Skipped } from "../../../../../../assets/icons/review.svg";
import { getCountryCode, getStatesByCountryCode } from "../../../../../../utils/countriesState";
import { uploadFileToS3 } from "../../../../../../utils/uploadFileToS3";
import { CommonToast } from "../../../../../common/Toast";
import { AddCompanyName } from "../Details/AddCompanyName";
export const FinancialStatement = ({ onPrev, onNext, onSkip }) => {
  const { token, userInfo } = useSelector((state) => state.auth);
  const stateRef = useRef(null);
  const { currentEditingCompany } = useSelector((state) => state.company);
  const countryRef = useRef(null);
  const [previewImage, setPreviewImage] = useState("");
  const [fileuploading, setfileuploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [CreateFinance] = useCreateFinanceMutation();
  const [FinanceDraftFetch] = useCreateFinanceDraftFetchMutation();
  const [CreateFinanceDraft] = useCreateFinanceDraftMutation();
  const [updateFinance] = useUpdateFinanceMutation();
  const [updateFinanceDraft] = useUpdateFinanceDraftMutation();
  const [updateFinanceDraftDetails] = useUpdateFinanceDraftDetailsMutation();
  const [renderPreviews, setRenderPreviews] = useState(true)

  const [createCompanyFinance] = useCreateCompanyFinanceMutation();
  const [createCompanyFinanceDraft] = useCreateCompanyFinanceDraftMutation();
  const [uploadedFile, setUploadedFile] = useState("");
  const [financialYearEndDate, setFinancialYearEndDate] = useState(null);
  const [lastAuditedDate, setLastAuditedDate] = useState(null);
  const [errors, setErrors] = useState({});
  const [countries] = useState(getCountryCode());
  const [selectedCountry, setSelectedCountry] = useState("");
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [financialDetails, setFinancialData] = useState("");
  const [showAddCompany, setShowAddCompany] = useState(true)
  const [search, setSearch] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [auditedFirmId, setAuditedFirmId] = useState(null);
  const [auditedFirmName, setAuditedFirmName] = useState(null);
  const [financialDetailsDraft, setFinancialDataDraft] = useState("");
  const [clearClicked, setClearClicked] = useState(false)

  //company register
  const [createCompany, { isLoading: companyCreating }] =
    useCreateCompanyMutation();

  const { data, refetch } = useGetCompanyQuery({
    companyId: auditedFirmId,
    token,
  });

  useEffect(() => {
    if (clearClicked) {
      setAuditedFirmName("")
      setFinancialYearEndDate("")
      setLastAuditedDate("")
      setSelectedCountry("")
      setUploadedFile("")
      setSelectedState("")
    } else {
      setClearClicked(false)
    }
  }, [clearClicked])

  const handleUpdateCompany = useCompanyUpdate();

  useEffect(() => {    
    if (data) {      
      setAuditedFirmId(data.companyID);
      setAuditedFirmName(data.registered_company_name);
    }
  }, [data]);

  useEffect(() => {
    setFinancialData(currentEditingCompany?.financialDetails);
    const companyStatus = async () => {
      let dataval = await FinanceDraftFetch({
        companyID: currentEditingCompany?.companyID,
        token,
      });
      if (dataval?.data?.data.length > 0) {
        setFinancialDataDraft(dataval?.data?.data[0]);
      }
    };
    companyStatus();
  }, [currentEditingCompany]);

  const handleCountryChange = async (e) => {
    const selectedCountryValue = e?.target?.value;
    setSelectedCountry(selectedCountryValue);
    setSelectedState("");

    const selectedCountryData = countries.find(
      (country) => country.countryCode === selectedCountryValue
    );

    if (selectedCountryData) {
      try {
        const states = await getStatesByCountryCode(selectedCountryData.countryCode)
        setStates([]);
        setTimeout(() => {
          setStates(states);
        }, [0])
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    }
  };

  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    setSelectedState(selectedState);
  };

  const formatDateToISO = (date) => {
    return date.toISOString().slice(0, 10);
  };

  const extractYearFromDate = (date) => {
    return date.getFullYear().toString();
  };

  useEffect(() => {
    if (
      financialDetails != null &&
      financialDetails != undefined &&
      financialDetails?.length !== 0
    ) {
      setAuditedFirmId(financialDetails[0]?.audit_firm_companyID);
      countryRef.current.value = financialDetails[0]?.country || "";
      setAuditedFirmName(financialDetails?.[0]?.audit_firm_name ?? "")
      setFinancialYearEndDate(
        financialDetails[0]?.financial_year_end && new Date(financialDetails[0]?.financial_year_end)
      );
      setLastAuditedDate(financialDetails[0]?.last_audited && new Date(financialDetails[0]?.last_audited, 0, 1));

      setSelectedCountry(financialDetails[0]?.country);

      const selectedCountryData = countries.find(
        (country) => country.countryCode === financialDetails[0]?.country
      );

      if (selectedCountryData) {
        let statesFn = async () => {
          const states = await getStatesByCountryCode(selectedCountryData.countryCode)
          setStates([]);
          setTimeout(() => {
            setStates(states);
          }, [0])
          setSelectedState(financialDetails[0]?.state);
        };
        statesFn();
      }
    }
  }, [financialDetails]);

  useEffect(() => {
    if (financialDetailsDraft) {
      setAuditedFirmId(financialDetailsDraft?.audit_firm_companyID_id);
      countryRef.current.value = financialDetailsDraft?.country || "";
      financialDetailsDraft?.audit_firm_name && setAuditedFirmName(financialDetailsDraft?.audit_firm_name)
      setFinancialYearEndDate(
        financialDetailsDraft?.financial_year_end
          ? new Date(financialDetailsDraft?.financial_year_end)
          : null
      );
      setLastAuditedDate(
        financialDetailsDraft?.last_audited
          ? new Date(financialDetailsDraft?.last_audited, 0, 1)
          : null
      );
      setSelectedCountry(financialDetailsDraft?.country);
      const selectedCountryData = countries.find(
        (country) => country.countryCode === financialDetailsDraft?.country
      );

      if (selectedCountryData) {
        let statesFn = async () => {
          const states = await getStatesByCountryCode(selectedCountryData.countryCode)
          setStates([]);
          setTimeout(() => {
            setStates(states);
          }, [0])
          setSelectedState(financialDetailsDraft?.state);
        };
        statesFn();
      }
      else {
        setSelectedState(financialDetailsDraft?.state ?? "");
      }
    }
  }, [financialDetailsDraft]);

  const renderPreview = () => {
    if (uploadedFile.type.includes("image")) {
      return <img src={previewImage} alt="trade" className="w-18" />;
    } else if (uploadedFile.type === "application/pdf") {
      return (
        <embed
          src={`${URL.createObjectURL(uploadedFile)}#page=1`}
          type="application/pdf"
          width="100%"
          height="500px"
        />
      );
    } else {
      return <p>Unsupported file type</p>;
    }
  };
  const renderPreview1 = (url) => {
    if (url != undefined) {
      if (!url.includes(".pdf")) {
        return <img src={url} alt="trade" className="w-18" />;
      } else {
        return (
          <embed
            src={url}
            type="application/pdf"
            width="100%"
            height="500px"
          />
        );
      }
    }

  };
  const handleFileSelect = async (file) => {
    setUploadedFile(file);
    setProgress(100);
    if (file && file.type.match("image.*")) {
      const reader = new FileReader();

      reader.onload = (e) => {
        setPreviewImage(e.target.result);
      };

      reader.readAsDataURL(file);
    } else {
      setPreviewImage(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const verifiedData = currentEditingCompany.verifiedCompany;
    const clientCompanyID = currentEditingCompany.companyID;
    if (isVerified(verifiedData)) {
      if (financialDetailsDraft) {
        try {
          const formData = new FormData();
          if (auditedFirmName === "" && financialYearEndDate === "" && lastAuditedDate === "" && selectedCountry === "" && uploadedFile === "" && selectedState === "") {
            formData.append("audited_financial_statement", null);
            formData.append(
              "financial_year_end",
              null
            );
            formData.append("last_audited", null);
            formData.append("state", null);
            formData.append("country", null);
            formData.append("audit_firm_companyID", null);
            formData.append("request_type", "Financial statement Update draft");
          } else {
            if (uploadedFile) {
              setfileuploading(true);
              const auditedUrl = await uploadFileToS3(
                uploadFilePath?.auditedFinancial,
                uploadedFile,
                token,
                currentEditingCompany?.companyID,
                "financial_statement"
              );
              if (auditedUrl) {
                setfileuploading(false);
              }
              formData.append("audited_financial_statement", auditedUrl?.url);
            }
            else {
              formData.append("audited_financial_statement", (renderPreviews ? (financialDetails[0]?.audited_financial_statement || financialDetailsDraft[0]?.audited_financial_statement) : null) ?? null);
            }
            formData.append("audit_firm_name", auditedFirmName);
            formData.append("financial_year_end", formatDateToISO(financialYearEndDate));
            formData.append("last_audited", extractYearFromDate(lastAuditedDate));
            formData.append("state", stateRef.current.value || selectedState);
            formData.append("country", selectedCountry || countryRef.current.value);
            formData.append("request_type", "Financial statement Update draft");
            formData.append("audit_firm_companyID", auditedFirmId ?? "");
          }
          const data = await updateFinanceDraftDetails({
            data: formData,
            token,
            company_financialID:
              financialDetailsDraft?.company_financial_draftID,
          }).unwrap();
          if (data) {
            if (!renderPreviews) {
              CommonToast.info(financialDetailsDraft.audited_financial_statement ? 'Document deleted successfully' :
                "The document is temporarily removed and sent for admin approval. Once approved, it will be permanently deleted.");
              setRenderPreviews(true);
            }
            setClearClicked(false)
            onNext(3, "Financial Documents", "Financial");
          }
        } catch (e) {
        } finally {
          setClearClicked(false)
          onNext(3, "Financial Documents", "Financial");
        }
      } else {
        try {
          const formData = new FormData();
          if (auditedFirmName === "" && financialYearEndDate === "" && lastAuditedDate === "" && selectedCountry === "" && uploadedFile === "" && selectedState === "") {
            formData.append("audited_financial_statement", null);
            formData.append("audit_firm_name", auditedFirmName);
            formData.append(
              "financial_year_end",
              null
            );
            formData.append("last_audited", null);
            formData.append("state", null);
            formData.append("country", null);
            formData.append("audit_firm_companyID", null);
            formData.append(
              "current_companyID",
              currentEditingCompany?.companyID
            );
            if (financialDetails[0]?.company_financialID != undefined) {
              formData.append(
                "company_financialID",
                financialDetails[0]?.company_financialID
              );
            }
            formData.append("request_type", "Financial statement create draft");
          } else {
            if (uploadedFile) {
              setfileuploading(true);
              const auditedUrl = await uploadFileToS3(
                uploadFilePath?.auditedFinancial,
                uploadedFile,
                token,
                currentEditingCompany?.companyID,
                "financial_statement"
              );
              if (auditedUrl) {
                setfileuploading(false);
              }
              formData.append("audited_financial_statement", auditedUrl?.url);
            } else {
              formData.append("audited_financial_statement", (renderPreviews ? (financialDetails[0]?.audited_financial_statement || financialDetailsDraft?.audited_financial_statement) : null) ?? null);
            }

            formData.append(
              "financial_year_end",
              formatDateToISO(financialYearEndDate)
            );
            formData.append("last_audited", extractYearFromDate(lastAuditedDate));
            formData.append("state", stateRef.current.value || selectedState);
            formData.append("country", selectedCountry || countryRef.current.value);
            formData.append(
              "current_companyID",
              currentEditingCompany?.companyID
            );
            if (financialDetails[0]?.company_financialID != undefined) {
              formData.append(
                "company_financialID",
                financialDetails[0]?.company_financialID
              );
            }

            formData.append("audit_firm_companyID", auditedFirmId ?? "");
            formData.append("audit_firm_name", auditedFirmName);
            formData.append("request_type", "Financial statement create draft");
          }
          const finance = await CreateFinanceDraft({
            data: formData,
            token,
          }).unwrap();

          if (finance.status === 200) {
            setClearClicked(false)
            onNext(3, "Financial Documents", "Financial");
          }
        } catch (e) {
        } finally {
          setClearClicked(false)
          onNext(3, "Financial Documents", "Financial");
        }
      }
    } else {
      if (
        financialDetails != undefined &&
        financialDetails != null &&
        financialDetails.length !== 0
      ) {
        try {
          const formData = new FormData();
          if (auditedFirmName === "" && financialYearEndDate === "" && lastAuditedDate === "" && selectedCountry === "" && uploadedFile === "" && selectedState === "") {
            formData.append("audited_financial_statement", null);
            formData.append(
              "financial_year_end",
              null
            );
            formData.append("last_audited", null);
            formData.append("state", null);
            formData.append("country", null);
            formData.append("audit_firm_companyID", null);
            formData.append("companyID", clientCompanyID);
          } else {
            if (uploadedFile) {
              setfileuploading(true);
              const auditedUrl = await uploadFileToS3(
                uploadFilePath?.auditedFinancial,
                uploadedFile,
                token,
                currentEditingCompany?.companyID,
                "financial_statement"
              );
              if (auditedUrl) {
                setfileuploading(false);
              }
              formData.append("audited_financial_statement", auditedUrl?.url);
            } else {
              formData.append("audited_financial_statement", (renderPreviews ? (financialDetails[0]?.audited_financial_statement || financialDetailsDraft?.audited_financial_statement) : null) ?? null);
            }
            formData.append(
              "financial_year_end",
              formatDateToISO(financialYearEndDate)
            );
            formData.append("last_audited", extractYearFromDate(lastAuditedDate));
            formData.append("state", stateRef.current.value || selectedState);
            formData.append("country", selectedCountry || countryRef.current.value);
            formData.append("audit_firm_companyID", auditedFirmId ?? "");
            formData.append("audit_firm_name", auditedFirmName);
            formData.append("companyID", clientCompanyID);
          }
          formData.append("status", "Requested");
          const data = await updateFinance({
            token,
            company_financialID: financialDetails[0]?.company_financialID,
            data: formData,
          }).unwrap();
          if (data) {
            setClearClicked(false)
            onNext(3, "Financial Documents", "Upload KK");
            const result = await handleUpdateCompany(
              currentEditingCompany.companyID,
              "Audit Firm Updated",
              token
            );
            if (!result.success) {
              console.error(result.error);
            }
          }
        } catch (e) {
        } finally {
          setClearClicked(false)
          onNext(3, "Financial Documents", "Financial");
        }
      } else {
        // if (!auditedFirmId) return;
        try {
          const formData = new FormData();
          if (auditedFirmName === "" && financialYearEndDate === "" && lastAuditedDate === "" && selectedCountry === "" && uploadedFile === "" && selectedState === "") {
            formData.append("audited_financial_statement", null);
            formData.append(
              "financial_year_end",
              null
            );
            formData.append("audit_firm_name", auditedFirmName);
            formData.append("companyID", clientCompanyID);
            formData.append("last_audited", null);
            formData.append("state", null);
            formData.append("country", null);
            formData.append("audit_firm_companyID", null);
          } else {
            if (uploadedFile) {
              setfileuploading(true);
              const auditedUrl = await uploadFileToS3(
                uploadFilePath?.auditedFinancial,
                uploadedFile,
                token,
                currentEditingCompany?.companyID,
                "financial_statement"
              );
              if (auditedUrl) {
                setfileuploading(false);
              }
              formData.append("audited_financial_statement", auditedUrl?.url);
            } else {
              formData.append("audited_financial_statement", (renderPreviews ? (financialDetails[0]?.audited_financial_statement || financialDetailsDraft?.audited_financial_statement) : null) ?? null);
            }
            formData.append(
              "financial_year_end",
              formatDateToISO(financialYearEndDate)
            );
            formData.append("last_audited", extractYearFromDate(lastAuditedDate));
            formData.append("state", stateRef.current.value || selectedState);
            formData.append("country", selectedCountry || countryRef.current.value);
            formData.append("audit_firm_companyID", auditedFirmId ?? "");
            formData.append("companyID", clientCompanyID);
            formData.append("audit_firm_name", auditedFirmName);
          }
          const finance = await CreateFinance({
            data: formData,
            token,
          }).unwrap();

          const result = await handleUpdateCompany(
            currentEditingCompany.companyID,
            "New Audit Firm Added",
            token
          );
          if (!result.success) {
            console.error(result.error);
          }

          if (finance.status === 200) {
            onNext(3, "Financial Documents", "Financial");
          }
        } catch (e) {
        } finally {
          onNext(3, "Financial Documents", "Financial");
        }
      }
    }
  };

  const handleSearchState = () => {
    setSearch((prev) => !prev);
    setShowAddCompany((prev) => !prev)
  }

  const modalHandle = (e) => {
    // e.preventDefault();
    setShowAddCompany((prev) => !prev)
    setSearch((prev) => !prev);
    setIsOpen((prev) => !prev);
    refetch();
  };

  const closeManualCompanyModal = () => {
    setSearch(true);
    setShowAddCompany(false)
    setIsOpen(false);
  }

  //handle submitted end

  const createCompanyFromWorldBox = async (worldBoxCompany) => {
    try {
      const { data, status } = await createCompany({
        data: {
          registered_company_name: worldBoxCompany.name,
          country_code: worldBoxCompany?.country,
          wb_win: worldBoxCompany?.win,
        },
        token,
      }).unwrap();

      // if (status === 201) {
      // const individualCompanyData = await individualCompany({
      //   data: {
      //     individualID: userInfo?.individual[0]?.individualID,
      //     companyID: data.companyID,
      //   },
      //   token,
      // });

      return data;
      // }
    } catch (error) { }
  };

  const getSelectedCompany = async (selectedCompany) => {
    try {
      if (selectedCompany?.country || selectedCompany?.country_code) {
        const selectedCountryValue = selectedCompany?.country || selectedCompany?.country_code;
        setSelectedCountry(selectedCountryValue);
        if (selectedCompany.state) {
          setSelectedState(selectedCompany.state)
        } else {
          setSelectedState("");
        }
        const selectedCountryData = countries.find(
          (country) => country.countryCode === selectedCountryValue
        );
        if (selectedCountryData) {
          try {
            const states = await getStatesByCountryCode(selectedCountryData.countryCode);
            setStates([]);
            setTimeout(() => {
              setStates(states);
            }, [0])
          } catch (error) {
            console.error("Error fetching states:", error);
          }
        }
      }
      if (selectedCompany) {
        if (selectedCompany?.win) {
          const company = await createCompanyFromWorldBox(selectedCompany);
          setAuditedFirmId(company?.companyID);
          setAuditedFirmName(company?.registered_company_name);

          refetch();
          setIsOpen(false);
        } else {
          setAuditedFirmId(selectedCompany.companyID);
          setAuditedFirmName(selectedCompany.registered_company_name || selectedCompany.name);
          setIsOpen(false);
        }
      }
    } catch (error) {

    } finally {
      setIsOpen(false)
      setSearch(true)
    }
  };
  function convertFileSize(size) {
    if (size < 1024) {
      return size + " B";
    } else if (size < 1024 * 1024) {
      return (size / 1024).toFixed(2) + " KB";
    } else {
      return (size / (1024 * 1024)).toFixed(2) + " MB";
    }
  }

  const handleRemoveFile = () => {
    setRenderPreviews(false);
    // setUploadedFile("")
  }

  const handleFormShow = (companyData) => {
    if (companyData) {
      setSearch(false);
      // setShowForm(true);
      // modalHandle();
      setShowAddCompany(false);
    }
  };

  return (
    <div className="mt-5 mr-20 ">
      <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2 flex">
        Auditor Information <span className="pendingapproval">
          {
            ((financialDetailsDraft && financialDetailsDraft?.status == 'raised')) ? <Requested /> :
              financialDetails.length > 0 && financialDetails[0]?.status === "Verified" ? <Verified /> : financialDetails[0]?.status === "Declined" ?
                <Declined /> : financialDetails[0]?.status === "Skipped" ? <Skipped /> : financialDetails[0]?.status === "Requested" && <Requested />
          }
        </span>
      </h3>

      <div
        className="border border-slate rounded-lg p-8 mb-6"
      >
        <label
          htmlFor="namefirm"
          className="block mb-1 text-primary text-f14 font-semibold text-left"
        >
          Audited Firm
        </label>
        <Button
          onClick={modalHandle}
          classes={`w-full text-left border focus:border-primary px-3 py-2 border-input rounded bg-inputDisable mb-4 ${false ? "hidden" : "block"
            }`}
        >
          {auditedFirmName ? auditedFirmName : "Search"}
        </Button>
        <div className="flex gap-4 w-full">
          <div className="mb-3 w-full">
            <label
              for="yearEnd"
              class="block mb-1 text-primary text-f14 font-semibold text-left"
            >
              Financial Year End
            </label>
            <DatePicker
              id="yearEnd"
              selected={financialYearEndDate}
              onChange={(date) => setFinancialYearEndDate(date)}
              dateFormat="MM/dd"
              className="w-full border border-input focus:border-primary px-3 py-2 rounded bg-input"
              placeholderText="Enter Financial Year End"
            />
          </div>

          <div className="mb-3 w-full">
            <label
              for="audited"
              class="block mb-1 text-primary text-f14 font-semibold text-left"
            >
              Last Audited
            </label>
            <DatePicker
              id="audited"
              selected={lastAuditedDate}
              onChange={(date) => setLastAuditedDate(date)}
              dateFormat="yyyy"
              maxDate={new Date()}
              showYearPicker
              className="w-full border border-input focus:border-primary px-3 py-2 rounded bg-input"
              placeholderText="Enter Last Audited"
            />
          </div>
        </div>

        <div className="flex gap-4 w-full">
          <div className="mb-3 w-full">
            <label
              for="country"
              class="block mb-1 text-primary text-f14 font-semibold text-left"
            >
              Country
            </label>
            <Select
              className="w-full border border-input focus:border-primary px-3 py-2 rounded bg-input"
              id="country"
              selectPropRef={countryRef}
              name="country"
              value={selectedCountry}
              onChange={handleCountryChange}
              disable={selectedCountry != '' ? true : false}
            >
              <option value="" disabled={selectedCountry != '' ? true : false} >Select a country</option>
              {countries
                .sort((a, b) => a.countryName.localeCompare(b.countryName))
                .map((country, index) => (
                  <option key={index} disabled={selectedCountry != '' ? true : false} value={country.countryCode}>
                    {country.countryName}
                  </option>
                ))}
            </Select>
          </div>

          <div className="mb-3 w-full">
            <label
              for="state"
              class="block mb-1 text-primary text-f14 font-semibold text-left"
            >
              State
            </label>
            {states.length >= 0 ? <Select
              className="w-full border border-input focus:border-primary px-3 py-2 rounded bg-input"
              id="state"
              selectPropRef={stateRef}
              name="state"
              value={selectedState}
              onChange={handleStateChange}
            >
              {/* <option value="">Select a state</option>
              {states?.length > 0 &&
                states?.map((state, index) => (
                  <option key={index} value={state.name}>
                    {state.name}
                  </option>
                ))} */}
              <option value="">Select a state</option>
              {states?.map((state) => <option key={state.state_code} value={state.name}>{state.name}</option>)}
            </Select> : <input
              id="state"
              ref={stateRef}
              name="state"
              value={selectedState}
              onChange={handleStateChange}
              error={errors.state}
              placeholder="Enter a state"
              disable={!selectedCountry}
              className={`w-full border border-input focus:border-primary px-3 py-2 rounded bg-input ${!selectedCountry ? "cursor-not-allowed" : "default"}`}
            />}
          </div>
        </div>

        {/* <label
          htmlFor=""
          className="block mb-1 text-primary text-f14 font-semibold text-left"
        >
          Upload Audited Financial Statement
        </label>
        {fileuploading ? <LoadingIcon /> : <UploadingInput onFileSelect={handleFileSelect} isUploading={true} />}

        {uploadedFile ? (
          <div className="bg-slate mt-2 p-3 rounded-md relative ">
            <div className="flex gap-3">
              <div
                className={`flex-auto w-16 ${uploadedFile.type === "application/pdf" ? "h-20" : "h-14"
                  } overflow-hidden`}
              >
                {renderPreview()}
              </div>
              <div className="flex flex-col items-start justify-center text-secondarytwo">
                <p className="text-f14">{uploadedFile.name}</p>
                <div>
                  <span className="text-f12 text-secondary">
                    {convertFileSize(uploadedFile.size)}
                  </span>
                </div>
              </div>
            </div>
            {true && (
              <div className="flex gap-3 items-center justify-start mt-3">
                <div className="bg-white h-2 rounded-full overflow-hidden relative w-full">
                  <div
                    className="bg-primary h-full transition-all"
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>
                <span className="">{progress}%</span>
              </div>
            )}

            {uploadedFile && (
              <button
                className="absolute right-3 top-3"
                onClick={() => setUploadedFile(null)}
              >
                <Close />
              </button>
            )}
          </div>
        ) :
          <div className="bg-slate mt-2 p-3 rounded-md relative ">
            <div className="flex gap-3">
              <div
                className={`flex-auto w-16 h-20 overflow-hidden`}
              >
                {renderPreviews && renderPreview1(financialDetailsDraft?.audited_financial_statement || financialDetails[0]?.audited_financial_statement)}
              </div>
            </div>
            {renderPreviews && (financialDetailsDraft?.audited_financial_statement || financialDetails[0]?.audited_financial_statement) && <button
              className="absolute right-3 top-3"
              onClick={handleRemoveFile}
            >
              <Close />
            </button>}
          </div>} */}
      </div>
      {isOpen && (
        <Modal modalHandle={modalHandle}>
          {search && <SearchCompanyStatement
            getSelectedCompanyFromSearch={getSelectedCompany}
            companyCreatingLoading={companyCreating}
            handleSearchState={handleSearchState}
          />}
          {showAddCompany && (
            <AddCompanyName
              handleAddNewCompany={closeManualCompanyModal}
              handleCompanySubmit={getSelectedCompany}
              breadNext={"Add Business Name"}
              breadPrev={"Select business"}
              label={"Business Details"}
            // handleSelectedCompany={getSelectedCompany}
            />
          )}
        </Modal>
      )}
      <BackNextButton
        onPrev={() => onPrev(1, "Insurance", "Financial")}  
        onNext={handleSubmit}
        onSkip={() => onSkip(3, "Financial Documents", "Financial")}
        isLoading={false}
        clear={true}
        setClearClicked={setClearClicked}
      />
    </div>
  );
};